module.exports = __webpack_public_path__ + "media/scholarship_winners/ryuto-sw-2a7b3b61.png";